import { render } from "./ShippingAddress.vue?vue&type=template&id=be908b0e&scoped=true"
import script from "./ShippingAddress.vue?vue&type=script&lang=js"
export * from "./ShippingAddress.vue?vue&type=script&lang=js"

import "./ShippingAddress.vue?vue&type=style&index=0&id=be908b0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be908b0e"]])

export default __exports__